/* Only server-selected, journal-verified old spray IDs can redirect. */
(() => {
  const element = document.getElementById('zm-old-variant-map');
  if (!element) return;
  let mapping;
  try { mapping = JSON.parse(element.textContent); } catch { return; }
  const current = new URL(window.location.href);
  const oldId = current.searchParams.get('variant');
  if (!oldId || !Object.prototype.hasOwnProperty.call(mapping, oldId)) return;
  const target = mapping[oldId];
  if (!target || !/^\/products\/[a-z0-9][a-z0-9-]*$/.test(target.path) ||
      !/^\d+$/.test(target.variant)) return;
  const next = new URL(current.href);
  next.pathname = target.path;
  next.searchParams.set('variant', target.variant);
  if (next.origin === current.origin && next.href !== current.href) {
    window.location.replace(next.href);
  }
})();
